import { useEffect } from "react";
import moment from 'moment';

// Event handlers to prevent default behavior
const preventDefault = (e) => {
  e.preventDefault();
};

const preventDefaultForScrollKeys = (e) => {
  // 33 - up arrow, 34 - down arrow, 35 - end, 36 - home
  const keys = [33, 34, 35, 36];
  if (keys.includes(e.keyCode)) {
    e.preventDefault();
  }
};

// Disable window scroll
export const onDisableWindowScroll = () => {
  window.addEventListener("wheel", preventDefault, { passive: false });
  window.addEventListener("touchmove", preventDefault, { passive: false });
  window.addEventListener("keydown", preventDefaultForScrollKeys, {
    passive: false,
  });
};

// Enable window scroll
export const onEnableWindowScroll = () => {
  window.removeEventListener("wheel", preventDefault);
  window.removeEventListener("touchmove", preventDefault);
  window.removeEventListener("keydown", preventDefaultForScrollKeys);
};

export const onOpenLinkInNewTab = (link) => {
  window.open(link, "_blank", "noopener, noreferrer");
};

// Hook
export const useOnClickOutside = (ref, handler) => {
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
};

// check if user_uid is included in array, if yes, we have to show the popup before the user clicks 'get started'
export const checkUserTypeToShowPopup = (arrayToCheck, url) => {
  const userUidHavingPopup = [59];
  const isIncluded = userUidHavingPopup.includes(arrayToCheck);

  if (isIncluded && url === "/get-started/1") {
    return true;
  }
  return false;
};

// generate date to sting format
export const generateDateString = (date) => {
  var dayName = moment(date).format('dddd');
  var dayDate = moment(date).format('DD');
  var month = moment(date).format('MMMM'); 
  // var year = moment(date).format('YYYY');
  var suffix = getSuffix(dayDate);
  var dateString = `${dayName}, ${dayDate}${suffix} ${month}`;
  return dateString;
}

// generate suffix date
export const getSuffix = (day) => {
  var suffixes = ["th", "st", "nd", "rd"];
  var lastDigit = day % 10;
  var suffix = day >= 11 && day <= 13 ? "th" : suffixes[lastDigit] || "th";
  return suffix;
}